module.exports = __webpack_public_path__ + "img/icon-midday.aea16231.svg";